import {
  axios_nomination,
} from '@/plugins/axios';
import configuration from '@/configurations';

class InteractionRepository {

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchInteractions(criteria) {
    const {
      company_id_list,
      contact_id_list,
      id_list,
      user_id_list,
      organization_id_list,
      type_id_list,
      date_upper_boundary,
      date_lower_boundary,
    } = criteria;

    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/interaction/search-interactions`,
      {
        company_id_list,
        contact_id_list,
        id_list,
        user_id_list,
        organization_id_list,
        type_id_list,
        date_upper_boundary,
        date_lower_boundary,
      }
    );

    return result.data;
  }

  async getUserStatistics(input) {
    const {
      date_upper_boundary,
      date_lower_boundary,
      type_name_list,
      user_id,
    } = input;

    if (!date_upper_boundary || !date_lower_boundary) {
      return {};
    }

    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/interaction/users/${user_id}/statistics`,
      {
        params: {
          date_upper_boundary,
          date_lower_boundary,
          type_name_list,
        },
      }
    );

    return result.data;
  }

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async getStatisticsByInteractionType(criteria) {
    const {
      company_id_list,
      contact_id_list,
      date_lower_boundary,
      date_upper_boundary,
      organization_id_list,
      type_name_list,
      user_id_list,
    } = criteria;

    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/interaction/statistics-by-interaction-type`,
      {
        company_id_list,
        contact_id_list,
        date_lower_boundary,
        date_upper_boundary,
        organization_id_list,
        type_name_list,
        user_id_list,
      }
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async createInteraction(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/interaction/interactions`,
      input
    );

    return result.data;
  }

  /**
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async getInteractions(input) {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/interaction/interactions`,
      {
        params: input,
      }
    );

    return result.data;
  }

  async deleteInteraction(interaction_id) {
    const result = await axios_nomination
      .delete(
        `${configuration.api_host}/v1/interaction/interactions/${interaction_id}`
      );

    return result.data;
  }
}

const interaction_repository = new InteractionRepository();

export {
  interaction_repository,
};
